// Import de namespace: con `import { z }` esbuild incluye todos los locales de zod 4 en el bundle
import * as z from 'zod';

import { DOMINE_KIUBIX } from '../config/keys.config';

// Schemas
export const authSchema = z.object({
  email: z.string().email().endsWith(DOMINE_KIUBIX),
  password: z.string().min(8)
});
export const emailSchema = z.string().email().endsWith(DOMINE_KIUBIX);
export const passwordSchema = z.string().min(8);

// Interfaces
export type AuthSchema = z.infer<typeof authSchema>;
